export default __webpack_public_path__ + "static/media/r-logo.b04966a4.png";